import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import authReducer from '../Auth/authReducer';
import controlsReducer from '../reducers/controlsReducer';
import userReducer from '../reducers/userReducer';
import ganymedeReducer from '../AppModules/Ganymede/ganymedeReducer';

const reducers = combineReducers({
  authReducer,
  controlsReducer,
  userReducer,
  ganymedeReducer,
});

export default createStore(reducers, composeWithDevTools(applyMiddleware(thunkMiddleware)));
